import bankAccounts from './bank-accounts';
import bankImports from './bank-imports';
import bankStatements from './bank-statements';
import bankTransactions from './bank-transactions';
import bankRules from './bank-rules';

let messages = Object.assign({}, bankAccounts, bankImports, bankStatements, bankTransactions, bankRules);

export default messages;
